// Which of the user's memberships the saved selection refers to. One person can
// hold several roles in a society (Resident and Secretary, say), each its own
// row with the same society_id, so the exact row is tried across the whole list
// before falling back to the society. The fallback is for a selection saved in
// an older shape, or a role that has since been removed.
export const resolveActiveMembership = (memberships, selected) => {
    const list = memberships || [];
    const exact = selected?.user_society_id != null
        && list.find((m) => m.user_society_id === selected.user_society_id);
    const sameSociety = selected?.society_id != null
        && list.find((m) => m.society_id === selected.society_id);
    return exact || sameSociety || list[0] || null;
};
